import { authHeader,logout, handleResponse } from '../helpers';
import Vue from 'vue';


export const kontrolaPredelavaService = {
    load,loadAll,loadLastYear,save,remove
    
};

function load(sezona,predelovalecid) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


    return fetch(`${Vue.prototype.$config.apiUrl}/predelava/predelovalec/kontrola/?sezona=${sezona}&predelovalecid=${predelovalecid}`, requestOptions)
        .then(handleResponse)
        .then(kontrola => {
            // login successful if there's a jwt token in the response
            
            return kontrola;
        });
}


function save(kontrola) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json',...authHeader()},
        body: JSON.stringify(kontrola)
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/predelava/predelovalec/kontrola`, requestOptions).then(handleResponse);
}


function remove(kontrola) {
    const requestOptions = {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json',...authHeader()},
        body: JSON.stringify(kontrola)
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/predelava/predelovalec/kontrola`, requestOptions).then(handleResponse);
}

function loadAll(sezona){
  const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


     return fetch(`${Vue.prototype.$config.apiUrl}/predelava/kontrole/?sezona=${sezona}`, requestOptions)
        .then(handleResponse)
        .then(kontrola => {
            // login successful if there's a jwt token in the response
            
            return kontrola;
        });
}

function loadLastYear(gerk,status){
    //in tu lahko napišem pravila ali pa jih enostavno potegnem iz baze preko api-ja
    return fetch(`${Vue.prototype.$config.apiUrl}/predelava/predelovalec/kontrola/?sezona=${sezona}&predelovalecid=${predelovalecid}`, requestOptions)
        .then(handleResponse)
        .then(kontrola => {
            // login successful if there's a jwt token in the response
            
            return kontrola;
        });

}
